
































































import Vue, { PropOptions } from 'vue';
import TopBar from '@/components/TopBar.vue';
import * as TypeVariable from '@/parts/VariableInput.vue';
import parts from '@/parts';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';

interface IItem {
  key: string;
  name: string;
}

const MODE_INVITATION = 'invitation';
const MODE_EDIT = 'edit';
const MODE_NORMAL = 'normal';

export default Vue.extend({
  name: 'coordinator',
  components: {
    ...parts, TopBar,
  },
  computed: {
    MODE_INVITATION(): string { return MODE_INVITATION; },
    MODE_EDIT(): string { return MODE_EDIT; },
    MODE_NORMAL(): string { return MODE_NORMAL; },
    CONST_PENDING(): string { return PClass.CONST.SELSMAN.PERMISTION.PENDING; },
    trDatas(): Models.ICoordinator[] {
      return this.getDatas.map((w) => {
        const rankArray = [] as string[];
        const userRank = this.getDatasRank.find((z) => (z.coordinatorID === w.id));
        if (userRank) {
          if (userRank.a) {rankArray.push('A')}
          if (userRank.b) {rankArray.push('B')}
          if (userRank.c) {rankArray.push('C')}
          if (userRank.d) {rankArray.push('D')}
        }
        return {...w, ...{rankSettings: rankArray.length > 0 ? rankArray.join(',') : '未設定'}}
      }).filter((v) => (v.coordinatorName.indexOf(this.searchWord) >= 0 || v.coordinatorMail.indexOf(this.searchWord) >= 0));
    },
    ROLE_EDIT(): boolean {
      return this.myData.role === PClass.CONST.ROLE.ADMIN || this.myData.role === 0},
  },
  props: {
    myData: Object as PropOptions<Models.ICoordinator>,
    confirmDialog: Function,
  },
  data() {
    return {
      mode: MODE_NORMAL,
      inputData: new Models.CCoordinator(),
      getDatas: [] as Models.ICoordinator[],
      searchWord: '',
      items: [
        {key: 'coordinatorName', name: '氏名', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'coordinatorMail', name: 'メールアドレス', type: TypeVariable.INPUT_TYPE.TEXT, required: true, checks: [TypeVariable.CHECK_TYPE.MAIL], error: '', max: 99, disabled: true},
        {key: 'header', name: 'ヘッダー', type: TypeVariable.INPUT_TYPE.TEXTAREA, required: false, error: '', max: 1500},
        {key: 'footer', name: 'フッダー', type: TypeVariable.INPUT_TYPE.TEXTAREA, required: false, error: '', max: 1500},
      ] as TypeVariable.IVariableInput[],
      thDatas: [
        {key: 'coordinatorName', name: '氏名'},
        {key: 'coordinatorMail', name: 'メールアドレス'},
        {key: 'permistion', name: '状態'},
        {key: 'rankSettings', name: '設定ランク'},
      ],
      inputDataRank: [] as number[],
      getDatasRank: [] as Models.ICoordinatorRank[],
      rankCheckBoxDisabled: true,
      /*
      trDatas: [
        // {id: 1, coordinatorName: 'testName', coordinatorMail: 'test', role: 2, header: 'testheader', footer: 'testfooter', permistion: '承認'},
      ] as Models.ICoordinator[],*/
    };
  },
  async mounted() {
    if (this.myData.role === PClass.CONST.ROLE.ADMIN || this.myData.role === 0) {
      this.rankCheckBoxDisabled = false;
    }
    await this.fncGASData();
  },
  methods: {
    async fncGASData(firstFlag = false) {
      const api = new PClass.API();
      const res = await api.get<any>('coordinator');
      console.log('res', res);
      if (!res.result.error) {
        this.getDatas = res.data.coordinators;
        this.getDatasRank = res.data.rank;
      }
    },
    onClickEditMode(data: any) {
      // console.log(this.myData)
      // this.inputData = this.getDatas.filter((v) => (v.id === this.myData.id))[0];
      this.inputDataRank = [] as number[];
      this.inputData = data;
      const userRank = this.getDatasRank.find((v) => (v.coordinatorID === data.id));

      if (userRank) {
        if (userRank.a) { this.inputDataRank.push(1)}
        if (userRank.b) {this.inputDataRank.push(2)}
        if (userRank.c) {this.inputDataRank.push(3)}
        if (userRank.d) {this.inputDataRank.push(4)}
      }

      // this.inputData = this.getDatas.filter((v) => (v.id === this.myData.id))[0];
      this.items[1].disabled = true;
      this.mode = MODE_EDIT;
    },
    async onClickEdit() {
      // validation エラーの場合
      // console.log('this.inputData', this.inputData)
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        return false;
      }

      const newRank = new Models.CCoordinatorRank();
      newRank.coordinatorID = this.inputData.id;
      newRank.a = this.inputDataRank.indexOf(1) > -1;
      newRank.b = this.inputDataRank.indexOf(2) > -1;
      newRank.c = this.inputDataRank.indexOf(3) > -1;
      newRank.d = this.inputDataRank.indexOf(4) > -1;
      const api = new PClass.API();
      const res = await api.post<any, any>('coordinator/edit', {...this.inputData, ...{rank: newRank}});
      // console.log(res);

      if (!res.result.error) {
        this.onClickCancel()
        this.getDatas = res.data.coordinators;
        this.getDatasRank = res.data.rank;
      } else {
        this.$emit('info', res.result.message);
      }
    },
    onClickInvitationMode() {
      this.inputData = new Models.CCoordinator();
      this.items[1].disabled = false;
      this.mode = MODE_INVITATION;
    },
    async onClickInvitation() {
      // validation エラーの場合
      // console.log('this.inputData', this.inputData)
      if (TypeVariable.checkValues(this.inputData, this.items) > 0) {
        return false;
      }

      // 相関チェック
      // 使用済みメールアドレスはエラー
      if (this.getDatas.filter((v) => (v.coordinatorMail === this.inputData.coordinatorMail)).length > 0) {
        this.items[1].error = '使用済みのメールアドレスです。';
        return false;
      }

      const api = new PClass.API();
      const res = await api.post<Models.ICoordinator, any>('coordinator/invitation', this.inputData);
      // console.log(res);

      if (!res.result.error) {
        this.onClickCancel();
        this.$emit('info', `${this.inputData.coordinatorMail}を招待しました。`);
        this.getDatas = res.data;
      } else {
        console.log(res);
        // this.$emit('info', res.result.message);
        this.$emit('errorInfo', res.result);
      }
    },
    async onClickResend(resendData: Models.ICoordinator) {
      if (await this.confirmDialog('招待メールを再送しますか？')) {
        console.log('resendDaata', resendData)
        const api = new PClass.API();
        const res = await api.post<Models.ICoordinator, any>('coordinator/reinvitation', resendData);

        if (!res.result.error) {
          this.$emit('info', '再度招待しました。');

        } else {
          this.$emit('info', res.result.message);
        }
      } else {
        console.log('close');
      }
    },
    onClickCancel() {
      this.mode = MODE_NORMAL;
    },
    async onClickDelete(deleteData: Models.IClient) {
      if (await this.confirmDialog('この利用者を削除します。\nよろしいでしょうか？')) {
        const api = new PClass.API();
        const res = await api.delete<Models.VClient>('coordinator', {id: deleteData.id});
        if (!res.result.error) {
          // await this.fncGASData();
          await this.fncGASData();
        } else {
          this.$emit('info', res.result.message);
        }
      }
    },
  },
});

